import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgUsersGroupFilled = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.298 15c-4.1 0-5 1.6-5 3.1.1 1.2.9 1.9 2 1.9h6c1.2 0 2-.8 2-2 0-1.4-.9-3-5-3M12.298 13.698c1.6 0 2.8-1.2 2.8-2.8s-1.2-2.8-2.8-2.8-2.8 1.2-2.8 2.8c0 1.5 1.3 2.8 2.8 2.8M17.398 10.1q-.3 0-.6.3c-.1.2-.2.4-.2.6.1 1.1 0 2.1-.4 3-.1.2-.1.5.1.7.1.2.4.3.6.3h2.9c1.1 0 1.9-.9 1.9-2.1.1-1.9-1.3-2.8-4.3-2.8M6.598 8.8c1.3 0 2.4-1.1 2.4-2.4S7.898 4 6.598 4s-2.4 1.1-2.4 2.4 1.1 2.4 2.4 2.4M17.698 8.8c1.3 0 2.4-1.1 2.4-2.4s-1.1-2.4-2.4-2.4-2.4 1.1-2.4 2.4 1.1 2.4 2.4 2.4M7.998 13.9c-.4-1-.5-1.9-.4-3 0-.2 0-.4-.2-.6q-.15-.3-.6-.3c-3 0-4.5 1-4.5 2.8 0 1.2.9 2.1 2 2.1h2.9c.2 0 .5-.1.6-.3.3-.2.3-.4.2-.7"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgUsersGroupFilled);
export default ForwardRef;
